import { useState } from "react";
import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import classes from "./RuleWizard.module.css";

const WizardStepSnapshotTiming = ({ onNext, onBack }) => {
    const { state, dispatch } = useRule();
    const mode = state.snapshotTimingMode;
    const delaySeconds = state.snapshotDelaySeconds;

    const [showDelayDialog, setShowDelayDialog] = useState(false);
    const [delayLength, setDelayLength] = useState(delaySeconds || 0);
    const [pendingMode, setPendingMode] = useState("DELAY");

    const setMode = (m) => dispatch({ type: "SET_SNAPSHOT_TIMING_MODE", payload: m });

    const openDelayDialog = (targetMode) => {
        setPendingMode(targetMode);
        setDelayLength(delaySeconds || 0);
        setShowDelayDialog(true);
    };

    const handleSetDelay = () => {
        dispatch({ type: "SET_SNAPSHOT_DELAY_SECONDS", payload: Number(delayLength) });
        setMode(pendingMode);
        setShowDelayDialog(false);
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>When should the snapshot be taken?</h2>
                <p className={classes.contentSubtitle}>Choose when the snapshot action fires relative to the rule triggering</p>
            </div>

            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "8px" }}>
                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "14px 18px",
                        border: `2px solid ${mode === "IMMEDIATE" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                    }}
                    onClick={() => setMode("IMMEDIATE")}
                >
                    <div style={{
                        width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                        border: `2px solid ${mode === "IMMEDIATE" ? "var(--Primary-Color)" : "#ccc"}`,
                        background: mode === "IMMEDIATE" ? "var(--Primary-Color)" : "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        {mode === "IMMEDIATE" && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
                    </div>
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Immediately</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Take the snapshot as soon as the rule conditions are met</p>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "14px 18px",
                        border: `2px solid ${mode === "DELAY" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                    }}
                    onClick={() => openDelayDialog("DELAY")}
                >
                    <div style={{
                        width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                        border: `2px solid ${mode === "DELAY" ? "var(--Primary-Color)" : "#ccc"}`,
                        background: mode === "DELAY" ? "var(--Primary-Color)" : "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        {mode === "DELAY" && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
                    </div>
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Delay</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>
                            {mode === "DELAY" ? `Wait ${delaySeconds}s before taking the snapshot` : "Wait before taking the snapshot"}
                        </p>
                    </div>
                </div>

                <Divider align="center" style={{ margin: "4px 0" }}>
                    <span style={{ color: "#9e9e9e", fontSize: "13px" }}>or</span>
                </Divider>

                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "14px 18px",
                        border: `2px solid ${mode === "BOTH" ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                    }}
                    onClick={() => openDelayDialog("BOTH")}
                >
                    <div style={{
                        width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                        border: `2px solid ${mode === "BOTH" ? "var(--Primary-Color)" : "#ccc"}`,
                        background: mode === "BOTH" ? "var(--Primary-Color)" : "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        {mode === "BOTH" && <span style={{ color: "white", fontSize: "11px", fontWeight: 700, lineHeight: 1 }}>✓</span>}
                    </div>
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Take a snapshot immediately AND take another after a specified delay</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>
                            {mode === "BOTH" ? `Also takes a second snapshot ${delaySeconds}s later` : "Creates two snapshot actions: one immediate, one delayed"}
                        </p>
                    </div>
                </div>
            </div>

            <Dialog
                header="Add delay (seconds)"
                visible={showDelayDialog}
                style={{ width: "34vw" }}
                onHide={() => setShowDelayDialog(false)}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <InputText
                        value={delayLength}
                        onChange={e => setDelayLength(e.target.value)}
                        placeholder="0"
                        style={{ width: "100px" }}
                    />
                    <span style={{ color: "#6e6e6e" }}>seconds</span>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        label="Set delay"
                        severity="success"
                        disabled={!delayLength || Number(delayLength) === 0}
                        onClick={handleSetDelay}
                    />
                </div>
            </Dialog>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />
                <Button label="Next" icon="pi pi-arrow-right" iconPos="right" severity="success" onClick={onNext} />
            </div>
        </>
    );
};

export default WizardStepSnapshotTiming;
